export const hmiConfig = {
  links: {
    hatdexRating:
      'https://docs.dataswift.io/knowledge-base/application-review/rating-assurance-and-certification',
    ownersAgreement: 'https://www.dataswift.io/legal/pda-owner-agreement-$lang',
    privacyPolicy: 'https://www.dataswift.io/legal/privacy-policy-$lang',
  },
};
